import { Component, useContext } from "solid-js"
import { Engine } from "../../lib/core/engine/Engine.type"
import { EntityLayerId } from "../../lib/core/entity/EntityLayerId/EntityLayerId.enum"
import EngineContext from "../EngineContext"
import { useEraseTileOptionSignal } from "../../rx/signal/useEraseTileOptionSignal"

const EraseTileSelect: Component = () => {
  const engine: Engine = useContext(EngineContext)
  const [getEraseTileOption, setEraseTileOption] = useEraseTileOptionSignal(engine)

  function toggleEntityLayerId(entity_yer_id: EntityLayerId) {
    return (/*event: Event*/) => {
      const eraseToolOption = getEraseTileOption()
      if (eraseToolOption.entity_layer_ids.includes(entity_yer_id)) {
        setEraseTileOption({
          ...eraseToolOption,
          entity_layer_ids: eraseToolOption.entity_layer_ids.filter(otherEntityLayerId => otherEntityLayerId !== entity_yer_id)
        })
      } else {
        setEraseTileOption({
          ...eraseToolOption,
          entity_layer_ids: [...eraseToolOption.entity_layer_ids, entity_yer_id]
        })
      }
    }
  }

  return <div id="MapEditorEraseTileSelect" class="card-body">
    Erase Tile
    <div class="entity-type-row">
      <input type="checkbox" id="TerrainL1"
        value={EntityLayerId.TerrainL1}
        checked={getEraseTileOption().entity_layer_ids.includes(EntityLayerId.TerrainL1)}
        onChange={toggleEntityLayerId(EntityLayerId.TerrainL1)}
      />
      <label for="TerrainL1">Terrain <small class="text-muted">Plain, Desert, Snow, Forest</small></label>
    </div>
    <div class="entity-type-row">
      <input type="checkbox" id="TerrainL2"
        value={EntityLayerId.TerrainL2}
        checked={getEraseTileOption().entity_layer_ids.includes(EntityLayerId.TerrainL2)}
        onChange={toggleEntityLayerId(EntityLayerId.TerrainL2)}
      />
      <label for="TerrainL2">Structures <small class="text-muted">Roads, Buildings</small></label>
    </div>
    <div class="entity-type-row">
      <input type="checkbox" id="Unit2"
        value={EntityLayerId.Unit2}
        checked={getEraseTileOption().entity_layer_ids.includes(EntityLayerId.Unit2)}
        onChange={toggleEntityLayerId(EntityLayerId.Unit2)}
      />
      <label for="Unit2">Units <small class="text-muted">Infantry, Tanks</small></label>
    </div>
    {/* <pre>EraseTileSelect {JSON.stringify({ eraseTileOption: getEraseTileOption() }, null, 2)}</pre> */}
  </div>
}

export default EraseTileSelect

